import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else {
      const finalCta = document.getElementById('final-cta');
      if (finalCta) {
        finalCta.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-gold hover:bg-gold-dark text-white font-bold py-4 px-8 rounded-sm shadow-lg transition-colors duration-300 uppercase tracking-wider text-sm md:text-base ${className}`} onClick={handleClick} {...props} data-id="element-12">
      {children}
    </motion.button>;
}